function Row({ children }) {
    return (<div className="Row">
        {children}
    </div>)
}

export default Row